import { Metamodel2 } from '@ardoq/api-types';
import { ApiResponse } from './types';
import { fetchJson, headers } from './api';

const fetch = (): ApiResponse<Metamodel2> => {
  const request = new Request('/api/metamodel2', { headers });
  return fetchJson<Metamodel2>(request);
};

export const metamodel2Api = {
  fetch,
};
